import { gql } from '@apollo/client';

export const fetchEmailsForTransactionAccountInPPC = gql`
  query fetchEmailsForTransactionAccountInPPC(
    $id: ID!
    $partnerAccountId: String!
    $searchParams: BillingAdminEmailSearchParams
  ) {
    transactionAccount(id: $id) {
      id
      emails(partnerAccountId: $partnerAccountId, searchParams: $searchParams) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        edges {
          node {
            attachments {
              contentType
              filename
              id
            }
            subject
            id
            date
          }
        }
      }
    }
  }
`;
